// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import { getMypage, updateMypage } from 'apis/my_page';
import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { MyPageFormDataMapper, MyPageResponse, MyPageType } from 'types/mypage';

type UseMypageContactInfoParams<T extends MyPageType> = {
  myPageType: T;
  enabled?: boolean;
};

export const useMypageContactInfo = <T extends MyPageType>({
  myPageType,
  enabled = true,
}: UseMypageContactInfoParams<T>) => {
  const [data, setData] = useState<MyPageResponse<T>>();
  const { t } = useTranslation();

  const fetchMypageData = useCallback(() => {
    if (!enabled || !myPageType) {
      return;
    }

    getMypage<T>({
      myPageType,
      callback: setData,
    });
  }, [enabled, myPageType]);

  useEffect(() => {
    fetchMypageData();
  }, [fetchMypageData]);

  const handleChangeInfo = useCallback(
    async (formData: MyPageFormDataMapper[T]) => {
      if (!enabled || !myPageType) return;

      let previousData: MyPageResponse<T> | undefined;
      setData((prev) => {
        previousData = prev;
        return prev ? { ...prev, ...formData } : prev;
      });

      await updateMypage<T>({
        myPageType,
        formData,
        callback: () => {
          toast.success(t('messages.M_011'));
          fetchMypageData();
        },
        errorCallback: () => setData(previousData),
      });
    },
    [enabled, fetchMypageData, myPageType, t]
  );

  return {
    data: data,
    fetchMypageData,
    handleChangeInfo,
  };
};
